import React from 'react';
import { AnswerSet } from '../AnswerSets/AnswerSet';

export default function LikertQuestionDetail({ question, ...props }) {
  const { answerSetConfig, answerSet } = question;

  return (
    <div>
      <AnswerSet
        {...props}
        answerSet={answerSet}
        answerSetConfig={answerSetConfig}
        question={question}
      />
    </div>
  );
}
